export default __webpack_public_path__ + "static/media/KevinB.11305234.png";